import './GrandLayout.css'
import { HeaderProvider } from "../../context/Header/HeaderContext";
import GrandNavbar from "../../features/GrandPage/GrandNavbar/GrandNavbar";
import FooterContainer from '../../components/Footer/FooterContainer/FooterContainer';

export default function GrandLayout({children}) {

    return (
        <main className="GrandLayout-main-container">
            <HeaderProvider>
                <GrandNavbar />
            </HeaderProvider>

            {children}
            <FooterContainer isGrand/>
        </main>
    )
}